import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  disclaimerPanel: {
    textAlign: 'center',
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
    marginBottom: '4rem',
  },
  title: {
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 700 },
    color: colors.neutral[900],
    margin: '0rem 0rem 1.6rem 0rem',
    letterSpacing: '0.03rem',
  },
  text: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 400 },
    color: colors.neutral[700],
    margin: '0rem 12.8rem 1.6rem 12.8rem',
    letterSpacing: '0.02rem',
  },
  buttonSection: {
    display: 'flex',
    justifyContent: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
